"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'autocomplete.triggers.suggestions': 'Elementi disponibili',
    'autocomplete.triggers.noResults': 'Nessun elemento corrispondente trovato',
    'autocomplete.triggers.stylesPlaceholder': 'Digita / per cercare stili...',
    'autocomplete.triggers.projectsPlaceholder': 'Digita # per cercare progetti...',
    'autocomplete.triggers.knowledgePlaceholder': 'Digita @ per cercare conoscenze...',
    'autocomplete.triggers.loading': 'Caricamento...',
    'autocomplete.triggers.error': 'Errore nel caricamento dei suggerimenti',
};
